class FolderService {

    constructor(SERVICE_LOCATIONS, $http, $q, $rootScope) {

        return {

            getFolder: (folderId) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + "folder/" + folderId)
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            //Need to get rid of one of these, dboth do literally the exact same thing...
            getFolders: (folderId) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + "folder/" + folderId + "/subfolders")
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            getSubfolders: (folderId) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + 'folder/' + folderId + "/subfolders")
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            searchOrFilterFolder: (folderId, filterExpression, searchExpression) => {

                let deferred = $q.defer();

                var type = encodeURIComponent(filterExpression);
                var search = searchExpression.length !== 0
                    ? encodeURIComponent(searchExpression)
                    : "*";

                $http.get("/api/folder/" + folderId + "/contents?type=" + type + "&search=" + search, { cache: false })
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            getFolderWithDescendants: (folderId) => {

                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + "folder/" + folderId + "/folderWithParents")
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            }

        };

    }

}

angular.module('cpm')
    .service('FolderService', ['SERVICE_LOCATIONS', '$http', '$q', '$rootScope', FolderService]);